export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50 tracking-wide">糖心影视</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              糖心影视平台提供海量高清影视资源免费在线观看，覆盖最新电影、热播电视剧全集。流畅不卡顿，即点即播，享受甜蜜观影体验。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '精选专题', href: '#carousel' },
                { label: '热度榜单', href: '#ranking' },
                { label: '热门推荐', href: '#cards' },
                { label: '话题标签', href: '#topics' },
                { label: '平台优势', href: '#features' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">帮助中心</h3>
            <ul className="space-y-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '关于糖心', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '移动观影', href: '#app' },
                { label: '最新动态', href: '#updates' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 糖心影视平台 - 高清免费在线观看。本站所有资源均来自网络，仅供学习交流使用。
          </p>
          <p className="text-xs text-background-600">
            糖心影视 · 甜蜜观影每一天
          </p>
        </div>
      </div>
    </footer>
  );
}